import { px2rem, opacify } from '../utils/helpers/style.js';
import { colors } from './colors.js';

var shadows = {
  /**
   * elemental-ui's small shadow
   */
  s: "0 0 ".concat(px2rem(8), " ").concat(px2rem(2), " ").concat(opacify(colors.fullBlack, 0.2)),
  /**
   * elemental-ui's base shadow
   */
  m: "0 0 ".concat(px2rem(27), " ").concat(px2rem(2), " ").concat(opacify(colors.fullBlack, 0.1))
};
var outerGlows = {
  /**
   * elemental-ui's small outer glow
   */
  s: "0 0 ".concat(px2rem(8), " ").concat(px2rem(2), " ").concat(opacify(colors.snowWhite, 0.2)),
  /**
   * elemental-ui's base outer glow
   */
  m: "0 0 ".concat(px2rem(27), " ").concat(px2rem(2), " ").concat(opacify(colors.snowWhite, 0.1))
};

export { outerGlows, shadows };
